import { render, staticRenderFns } from "./table-settings.vue?vue&type=template&id=0358f021&scoped=true"
import script from "./table-settings.vue?vue&type=script&lang=js"
export * from "./table-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0358f021",
  null
  
)

export default component.exports